import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Retourne le nom d'affichage du véhicule.
 * Combine nom + modèle intelligemment, filtre "Nouveau véhicule".
 */
export function vehicleName(v) {
  const nom = (v.nom && v.nom !== 'Nouveau véhicule') ? v.nom.trim() : '';
  const modele = (v.modele || '').trim();
  if (nom && modele && !nom.toLowerCase().includes(modele.toLowerCase())) {
    return `${nom} ${modele}`;
  }
  return nom || modele || 'Véhicule';
}
